{getIdsAsList} = require("../../utils")

module.exports = () ->
  return {
    scope:
      comments:                        "="
      canAddComment:                   "&commentsListCanAddComment"
      canEditCommentByUser:            "&commentsListCanEditCommentByUser"
      canEditCommentByUsersOtherThan:  "&commentsListCanEditCommentByUsersOtherThan"
      contentType:                     "@"
      doc:                             "&"

    controller: ($scope) ->
      $scope.onSave = (newComment) ->
        if !$scope.comments?
          $scope.comments = [newComment]
        else if newComment.id not in getIdsAsList($scope.comments, "id")
          # Insert a new comment
          $scope.comments.push(newComment)
        else
          # Update an existing comment
          for oldComment, i in $scope.comments
            if oldComment.id is newComment.id
              $scope.comments[i] = newComment

      $scope.canEditComment = (comment) ->
        user = $scope.canEditCommentByUser()
        usersOtherThan = $scope.canEditCommentByUsersOtherThan()
        return (user && comment.owner.id == user.id) || (usersOtherThan && usersOtherThan.id != comment.owner.id)

    template: require("./comments-list.html")
  }
